import RxShoppingCartItem from "./RxShoppingCartItem";

export default RxShoppingCartItem;
